import { queryOptions } from "@tanstack/react-query";
import { createServerFn } from "@tanstack/react-start";
import { getApiClient, getSessionCookieHeader } from "~/utils/api-client";

const TEAM_MEMBERS_KEYS = {
	all: ["team-members"] as const,
	self: () => [...TEAM_MEMBERS_KEYS.all, "self"] as const,
};

type TeamMemberPerson = {
	person_id: number;
	first_name: string;
	last_name: string;
	email: string;
	avatar_url: string | null;
	employment: { employment_id: number } | null;
};

/**
 * Get all team members for the current authenticated user
 * (people who share at least one team with the current user)
 */
const teamMembersQueryOptions = queryOptions({
	queryKey: TEAM_MEMBERS_KEYS.self(),
	queryFn: () => fetchTeamMembers(),
	// Cache for 5 minutes - team memberships don't change often
	staleTime: 5 * 60 * 1000,
	// Keep in cache even when unused
	gcTime: 10 * 60 * 1000,
});

const fetchTeamMembers = createServerFn({
	method: "GET",
	// Hono types unknown JSON fields broadly; the API response is already JSON.
	strict: { output: false },
}).handler(async () => {
	const api_client = getApiClient(getSessionCookieHeader());

	const result = await api_client.self.api["team-members"].$get();

	if (!result.ok) {
		throw new Error("Failed to fetch team members");
	}

	return await result.json();
});

export { teamMembersQueryOptions };
export type { TeamMemberPerson };
